import React from 'react'
import Footer from '../../components/footer/Footer'
import Navbar from '../../components/navbar/Navbar'

const Sermon = () => {
  return (
    <div>
      <Navbar />
      Sermon
      <Footer />
      </div>
  )
}

export default Sermon